import { IM190BrandOverviewModule } from '~/lib/data-contract';
import { DynamicCallToAction } from '~/shared/components/DynamicCallToAction/DynamicCallToAction';
import { RawHtml } from '~/shared/components/RawHtml/RawHtml';

import styles from './m190content.module.css';

export type M190ContentProps = Pick<IM190BrandOverviewModule, 'headline' | 'text' | 'shopAllCallToAction'>;

export const M190Content = ({ headline, text, shopAllCallToAction }: M190ContentProps) => {
	return (
		/* Don't remove this div. I know it's tempting, but don't. */
		<div>
			<div
				className={styles.headline}
				dangerouslySetInnerHTML={headline?.html ? { __html: headline.html } : undefined}
			/>
			{text ? <RawHtml html={text.html} /> : null}
			{shopAllCallToAction ? (
				<DynamicCallToAction
					className={styles.cta}
					callToAction={shopAllCallToAction}
					defaultStyle="arrow"
				/>
			) : null}
		</div>
	);
};
